import { getExperimentParamSync } from 'src/utils/experimentNew'

export const MIGRATED_ROUTE_MODULES_EXPERIMENT_NAME =
  'exp2601-migrated-route-modules'

const variant = getExperimentParamSync<'control' | 'treatment'>(
  MIGRATED_ROUTE_MODULES_EXPERIMENT_NAME,
)

export const isMigratedRouteModulesEnabled = variant === 'treatment'
